module.exports = __webpack_public_path__ + "img/btn.782f1cb1.png";